import axios from "axios";

export const setAuthToken = token => {
  if (token) {
    // Apply authorization token to every request if logged in
    axios.defaults.headers.common["authorization"] = token;
  } else {
    // Delete auth header
    delete axios.defaults.headers.common["authorization"];
  }
};
export const encodeforspace = pathname => {
  pathname = pathname.split(' ')
    .map(encodeURIComponent)
    .join('_')
  return pathname.replace(/%26/g, "&");
}
export const decodeforspace = pathname => {
  if(!pathname) return pathname
  pathname = pathname.replace(/&/g, "%26");
  return pathname.split('_')
    .map(decodeURI)
    .join(' ')

}

export const cutString = (content, count) => content && content.length > count ? `${content.substring(0, count)}...` : content
export const decodeIndustryName = industry => {
  let _industry = decodeURIComponent(industry);
  if (_industry == 'Hospital_Healthcare') _industry = 'Hospital/Healthcare'
  if (_industry == 'Energy_Oil') _industry = 'Energy/Oil'
  if (_industry == 'Real_Estate') _industry = 'Real Estate'
  if (_industry == 'Tech_Services') _industry = 'Tech Services'
  if (_industry == 'PR_Comm') _industry = 'PR/Comm'
  if (_industry == 'VC_PE') _industry = 'VC/PE'
  return _industry
}

export const encodeIndustryName = industry => {
  var _industry = industry
  if (industry == 'Hospital/Healthcare') _industry = 'Hospital_Healthcare'
  if (industry == 'Energy/Oil') _industry = 'Energy_Oil'
  if (industry == 'Real Estate') _industry = 'Real_Estate'
  if (industry == 'Tech Services') _industry = 'Tech_Services'
  if (industry == 'PR/Comm') _industry = 'PR_Comm'
  if (industry == 'VC/PE') _industry = 'VC_PE'
  return _industry
}

export const amountFormatter = (num, digits) => {
  const lookup = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "k" },
    { value: 1e6, symbol: "M" },
    { value: 1e9, symbol: "B" },
    { value: 1e12, symbol: "T" },
    { value: 1e15, symbol: "P" },
    { value: 1e18, symbol: "E" }
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var item = lookup.slice().reverse().find(function (item) {
    return num >= item.value;
  });
  return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
}

export const showEzoicAds = placeholders => {

  return ;
  console.log('adding ', placeholders)
  var ezstandalone = window.ezstandalone || {};
  if (typeof window.ezstandalone ) {
    ezstandalone.cmd = ezstandalone.cmd || [];
    ezstandalone.cmd.push(() => {
      // ezstandalone.destroy();
      ezstandalone.define(placeholders);
      // ezstandalone.displayMore(placeholders);
      // ezstandalone.refresh();

      setTimeout(() => {
        ezstandalone.refresh();
      }, 1000)


    });
  }

};


// WEBPACK FOOTER //
// ./client/src/utils/helper.js